export default __webpack_public_path__ + "static/media/msf.cf16fd62.svg";